import { styled, alpha } from '@mui/material/styles';
import { LOG_LEVEL_PALETTE_COLORS, LogLevel } from './logLevels.ts';

export const StyledInformationDialog = styled('div')(({ theme }) => ({
  width: '100%',
  '.react-lazylog': {
    background: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  '.react-lazylog-searchbar': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1.5),
    color: theme.palette.text.secondary,
    background: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '.react-lazylog-searchbar-matches': {
    padding: theme.spacing(0, 0.5),
    fontSize: '0.72rem',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    color: theme.palette.text.secondary,
    '&.active': { color: theme.palette.primary.light },
    '&.inactive': { color: alpha(theme.palette.text.primary, 0.4) },
  },
  '.react-lazylog-searchbar-input': {
    height: 28,
    width: 150,
    borderRadius: 7,
    padding: '0 10px',
    fontSize: '0.8rem',
    background: theme.palette.background.default,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
    outline: 'none',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&::placeholder': { color: theme.palette.text.secondary, opacity: 1 },
    '&:hover': { borderColor: alpha(theme.palette.primary.main, 0.5) },
    '&:focus': {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.15)}`,
    },
  },
  '.react-lazylog-searchbar-filter, .react-lazylog-searchbar-up-arrow, .react-lazylog-searchbar-down-arrow': {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    padding: 0,
    borderRadius: 7,
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.default,
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    transition: theme.transitions.create(['background-color', 'border-color', 'color']),
    '& svg': { width: 15, height: 15, fill: 'currentColor' },
    '&:hover': {
      color: theme.palette.text.primary,
      borderColor: theme.palette.primary.main,
      background: alpha(theme.palette.primary.main, 0.14),
    },
    '&.active': {
      color: theme.palette.primary.light,
      borderColor: alpha(theme.palette.primary.main, 0.5),
      background: alpha(theme.palette.primary.main, 0.12),
    },
    '&.inactive': { opacity: 0.45, cursor: 'default' },
  },
  '.log-line': {
    '&:hover': {
      backgroundColor: alpha(theme.palette.text.primary, 0.1),
    },
  },
}));

export const StyledLogLevel = styled('span')<{ level: LogLevel }>(({ level, theme }) => ({
  fontWeight: 'bold',
  color: theme.palette[LOG_LEVEL_PALETTE_COLORS[level]].main,
  padding: '0.2em',
  borderRadius: '3px',
  textTransform: 'uppercase',
}));
